/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
export default function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify/node_modules/dom-helpers/esm/hasClass.js
// module id = ./node_modules/react-toastify/node_modules/dom-helpers/esm/hasClass.js
// module chunks = main